import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import Modal from "../sections/MUI/Modal";
import Field from "../sections/MUI/Field";
import File from "../sections/MUI/File";
import Button from "../sections/MUI/Button";
import Back from "../sections/Back";
import Icon from "../sections/MUI/Icon";
import {toast} from "react-toastify";

class Services extends Component {

    state = {
        search: "",
        services: [],
        categories: [],

        title: "",
        image: null,
        price: "",
        category: [],
        options: [],
        description: "",
        gadgets: [],

        modalAdd: false,
        modalCategory: false,

        option: "",
        gadget: ""
    };


    componentDidMount() {
        this.getCategories();
        this.getServices();
    }

    getCategories() {
        axios.get(`${config.api}/admin/categories?token=${config.token}`)
            .then(r => {
                this.setState({
                    categories: r.data.categories
                });
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    getServices(search = "") {
        axios.get(`${config.api}/admin/service?token=${config.token}&search=${search}`)
            .then(r => {
                this.setState({services: r.data.result});
            })
            .catch(err => {
                config.handleError(err);
            });
    }


    renderChildrenCategories(children) {
        return children ? children.length > 0 ?
            <div className="sub-categories">
                {
                    children.map((scat, i) =>
                        <div
                            key={"scat" + i} className="row">
                            <div className="col-auto">
                                <div
                                    style={this.categoryIsSelected(scat._id) ? {
                                        color: "#0a940a",
                                        fontWeight: 600
                                    } : {
                                        color: "#656565",
                                        fontWeight: 500
                                    }}
                                    className="title"
                                    onClick={() => this.handleCategoryClick(scat._id)}>-&nbsp;{scat.title}</div>
                                <div>
                                    {this.renderChildrenCategories(scat.children)}
                                </div>
                            </div>

                        </div>
                    )
                }
            </div> : null : null;

    }


    categoryIsSelected(id) {
        const {category} = this.state;
        return category.includes(id)
    }

    handleCategoryClick(id) {
        let {category} = this.state;
        let isSelected = false;
        category.map((c, i) => {
            if (c === id) {
                isSelected = true;
                category.splice(i, 1);
            }
        })
        if (!isSelected) {
            category.push(id);
        }

        this.setState({category});
    }

    handleOptionChange(index, value) {
        let {options} = this.state;
        options[index] = value;
        this.setState({options});
    }

    handleRemoveOption(index) {
        let {options} = this.state;
        options.splice(index, 1);
        this.setState({options});
    }

    handleAddOption() {
        let {option, options} = this.state;
        options.push(option);

        this.setState({options, option: ""});
    }

    handleGadgetChange(index, value) {
        let {gadgets} = this.state;
        gadgets[index] = value;
        this.setState({gadgets});
    }

    handleRemoveGadget(index) {
        let {gadgets} = this.state;
        gadgets.splice(index, 1);
        this.setState({gadgets});
    }

    handleAddGadget() {
        let {gadget, gadgets} = this.state;
        gadgets.push(gadget);

        this.setState({gadgets, gadget: ""});
    }


    submit() {
        const {title, image, price, category, options, description, gadgets} = this.state;
        if (title !== "" && image && price !== "" && category.length > 0 && description !== "") {
            let params = new FormData();
            params.append("title", title);
            params.append("image", image);
            params.append("price", price.toString().replace(/,/g, "").toString().trim());
            params.append("category", JSON.stringify(category));
            params.append("options", JSON.stringify(options));
            params.append("gadgets", JSON.stringify(gadgets));
            params.append("meta", JSON.stringify({
                description
            }));
            toast.info("در حال ثبت ...");
            axios.post(`${config.api}/admin/service?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    toast.success("با موفقت ثبت شد");
                    this.setState({
                        title: "",
                        image: null,
                        price: "",
                        category: [],
                        options: [],
                        description: "",
                        gadgets: [],

                        modalAdd: false,
                        modalCategory: false,

                        option: "",
                        gadget: ""
                    });
                })
                .catch(err => {
                    config.handleError(err)
                });
        } else {
            toast.error("همه فیلد ها را تکمیل کنید.")
        }

    }

    render() {
        const {
            search,
            services, categories, modalAdd, modalCategory,
            title, image, price, category, options, description, gadgets,
            option, gadget
        } = this.state;
        return (
            <div className="services">
                {modalCategory ?
                    <Modal display={modalCategory}
                           zIndex={999999}
                           title="انتخاب دسته بندی"
                           icon="list"
                           onCloseClick={() => this.setState({modalCategory: false})}>
                        <div className="modal-select-categories">
                            {
                                categories ?
                                    categories.length > 0 ?
                                        categories.map((c, i) =>
                                            <div id={"c" + i} className="category" key={"c__" + i}>

                                                <div
                                                    className="title"
                                                    style={this.categoryIsSelected(c._id) ? {
                                                        color: "#0a940a",
                                                        fontWeight: 600
                                                    } : {
                                                        color: "#656565",
                                                        fontWeight: 500
                                                    }}
                                                    onClick={() => this.handleCategoryClick(c._id)}>{c.title}</div>
                                                {
                                                    c.children ? this.renderChildrenCategories(c.children)
                                                        : null
                                                }

                                            </div>
                                        )
                                        : <div>لیست دسته بندی خالی است</div>
                                    : null
                            }
                        </div>
                    </Modal>
                    : null}
                {modalAdd ?
                    <Modal display={modalAdd}
                           title="ثبت سرویس"
                           icon="check"
                           onCloseClick={() => this.setState({modalAdd: false})}>
                        <div className="modal-add-service">
                            <Field name="title"
                                   value={title}
                                   label="عنوان"
                                   maxLength={300}
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                            <File name="image"
                                  value={image}
                                  label="عکس خدمت"
                                  accept="image/*"
                                  multiple={false}
                                  onChange={(name, value) => this.setState({[name]: value})}/>

                            <Field name="price"
                                   value={price}
                                   label="قیمت هر ساعت"
                                   maxLength={30}
                                   style={{direction: "ltr"}}
                                   typePrice
                                   onChange={(name, value) => this.setState({[name]: value})}/>

                            <Button submit={false} icon="list"
                                    onClick={() => this.setState({modalCategory: true})}>انتخاب دسته بندی</Button>
                            <Field name="description"
                                   value={description}
                                   label="توضیحات متا"
                                   maxLength={1500}
                                   type="textarea"
                                   row={3}
                                   onChange={(name, value) => this.setState({[name]: value})}/>

                            <div>گزینه ها:</div>
                            <div className="row">
                                <div className="col">
                                    <Field name="option"
                                           value={option}
                                           label="گزینه"
                                           maxLength={300}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-auto">
                                    <Icon i="plus" className="add-option-icon"
                                          onClick={() => this.handleAddOption()}/>
                                </div>
                            </div>
                            {
                                options.map((o, i) =>
                                    <div className="row" key={"opt" + i}>
                                        <div className="col">
                                            <Field name="option"
                                                   label="گزینه"
                                                   value={o}
                                                   onChange={(name, value) => this.handleOptionChange(i, value)}/>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="minus" className="remove-option-icon"
                                                  onClick={() => this.handleRemoveOption(i)}/>
                                        </div>
                                    </div>
                                )
                            }

                            <div>ابزار ها:</div>

                            <div className="row">
                                <div className="col">
                                    <Field name="gadget"
                                           value={gadget}
                                           label="ابزار"
                                           maxLength={300}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-auto">
                                    <Icon i="plus" className="add-gadget-icon"
                                          onClick={() => this.handleAddGadget()}/>
                                </div>
                            </div>
                            {
                                gadgets.map((o, i) =>
                                    <div className="row" key={"opt" + i}>
                                        <div className="col">
                                            <Field name="gadget"
                                                   label="ابزار"
                                                   value={o}
                                                   onChange={(name, value) => this.handleGadgetChange(i, value)}/>
                                        </div>
                                        <div className="col-auto">
                                            <Icon i="minus" className="remove-option-icon"
                                                  onClick={() => this.handleRemoveGadget(i)}/>
                                        </div>
                                    </div>
                                )
                            }

                            <div className="row justify-content-center">
                                <div className="col-md-5">
                                    <Button submit={false} icon="plus" onClick={() => this.submit()}>ثبت کردن</Button>
                                </div>
                            </div>
                        </div>

                    </Modal>
                    : null
                }

                <Back {...this.props}/>

                <div className="row">
                    <div className="col-md-5">
                        <Button submit={false} icon="plus" onClick={() => this.setState({modalAdd: true})}>ثبت
                            سرویس</Button>
                    </div>
                </div>

                <br/>
                <div className="list">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <Field name="search"
                                   value={search}
                                   label="جستجو"
                                   onChange={(name, value) => {
                                       this.setState({
                                           [name]: value,
                                           services: []
                                       });
                                       this.getServices(value);
                                   }}/>
                        </div>
                    </div>
                    {
                        services.map((s, i) =>
                            <article key={"service" + i}>
                                <div className="row">
                                    <div className="col-auto">
                                        <div className="image">
                                            <img src={s.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="title">{s.title}</p>
                                    </div>
                                    <div className="col-auto">
                                        <Icon i="edit" className="edit-icon"
                                              onClick={() => this.props.navigate(`/service/${s.id}`)}/>

                                    </div>
                                </div>
                            </article>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default gpn(Services);